// @ts-check
/**
 * @file useOnlineStatus.js
 * @location src/hooks/useOnlineStatus.js
 * @role navigator.onLine 추적 — online/offline 이벤트로 갱신. OfflineIndicator 표시용.
 */
import { useState, useEffect } from 'react';

export function useOnlineStatus() {
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  return online;
}
